import { safeSessionStorage } from '@repo/lib/storage';
import { GraphQLClient } from 'graphql-request';
import { env } from '../utils/env';
import { getRetailerFromUrl } from '../utils/getRetailerFromUrl';
import { STORAGE_KEYS } from '../utils/constants';

const searchParams = new URLSearchParams(window.location.search);
const retailer = getRetailerFromUrl();
if (retailer) {
  searchParams.set('retailer', retailer);
}

export const createGraphQLClient = (): GraphQLClient => {
  const token = safeSessionStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  const retailer = getRetailerFromUrl();
  const searchParams = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : '',
  );

  if (retailer) {
    searchParams.set('retailer', retailer);
  }

  const url = `${env.VITE_PDP_GRAPHQL_URL}?${searchParams.toString()}`;

  return new GraphQLClient(url, {
    headers: token
      ? {
          'X-Authentication': token,
        }
      : {},
  });
};

export const client = createGraphQLClient();
